import { jsx, jsxs } from 'react/jsx-runtime';
import { IconArrowBox } from '@wds/icons';
import { safeRest } from '@wds/utils';
import { createMemoStyles } from '@wds/styles';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var useStyles = createMemoStyles(function (_a) {
  var palette = _a.palette,
    type = _a.type,
    spacing = _a.spacing;
  return {
    wrenchLink: {
      boxSizing: 'border-box',
      fontFamily: type.fontFamily.base,
      '-webkit-font-smoothing': 'antialiased',
      color: function (_a) {
        var color = _a.color;
        return color === 'light' ? palette.text.light : palette.text.link;
      },
      border: 'none',
      background: 'none',
      fontWeight: 'inherit',
      fontSize: 'inherit',
      cursor: 'pointer',
      textDecoration: function (_a) {
        var underline = _a.underline;
        return underline ? 'underline' : 'none';
      },
      display: 'inline-flex',
      alignItems: 'center',
      '&:hover, &:focus': {
        textDecoration: function (_a) {
          var underline = _a.underline;
          return underline ? 'none' : 'underline';
        }
      }
    },
    wrenchLinkNewTab: function () {
      return {
        paddingLeft: spacing[2],
        display: 'inline-flex',
        alignItems: 'center'
      };
    }
  };
});

var Link = function Link(_a) {
  var children = _a.children,
    color = _a.color,
    _b = _a.underline,
    underline = _b === void 0 ? true : _b,
    _c = _a.newTabLabel,
    newTabLabel = _c === void 0 ? 'This link opens in a new tab' : _c,
    rest = __rest(_a, ["children", "color", "underline", "newTabLabel"]);
  var _d = useStyles({
      color: color,
      underline: underline
    }),
    wrenchLink = _d.wrenchLink,
    wrenchLinkNewTab = _d.wrenchLinkNewTab;
  var newTabIcon = rest.target && rest.target === '_blank' ? jsx("span", {
    className: wrenchLinkNewTab,
    children: jsx(IconArrowBox, {
      title: newTabLabel,
      "aria-label": newTabLabel,
      size: "sm"
    })
  }) : null;
  if (newTabIcon) {
    return jsxs("a", __assign({
      className: wrenchLink
    }, safeRest(rest), {
      children: [children, newTabIcon]
    }));
  }
  return jsx("a", __assign({
    className: wrenchLink
  }, safeRest(rest), {
    children: children
  }));
};

var LINK_COLORS = ['light', 'dark'];

export { LINK_COLORS, Link };
